import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

/* TODO: Dodać kiedyś LOCIZE, aby łatwiej zarządzać tłumaczeniami */

export const languageList = ['pl', 'en'];

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        detection: {
            order: [
                'querystring',
                'cookie',
                'localStorage',
                'sessionStorage',
                'path',
                'subdomain',
            ],
            caches: ['cookie', 'localStorage'],
        },
        supportedLngs: languageList,
        fallbackLng: 'pl',
        lng: 'pl',
        debug: false,
        interpolation: {
            escapeValue: false,
        },
    });
